export const THEME_COLORS = {
    LC: "#3531AC",
    SA: "#9EA5F8",
    TM: "#BDCFFB",
    SM: "#6A4C93",
    TL: "#007A66",
    DC: "#ABD4CC",
    LS: "#FFCAA7",
    PS: "#FEBACF",
    SO: "#F79151",
    PH: "#c7f0d2",
    FH: "#F1CC72",
}

export function getThemeColor(themeCode) {
    return THEME_COLORS[themeCode] || "#D0D0D0"
}

export function getTopicDisplayName(topicCode, topicData, intl) {
    if (topicData?.taxonomy) {
        return intl.formatMessage({
            id: 'topic.' + topicCode,
            defaultMessage: topicCode
        });
    }
    return topicData?.title || topicCode;
}

/**
 * Resolves a topic display name using a raw translations map (e.g. from GetGeneralTranslations)
 * instead of intl. Use this for system instructions where the language should match the
 * survey/bot language, not the admin UI language.
 */
export function getTopicDisplayNameFromTranslations(topicCode, topicData, translations) {
    if (topicData?.taxonomy && translations) {
        return translations['topic.' + topicCode] || topicCode;
    }
    return topicData?.title || topicCode;
}

export function groupTopicsByTheme(categoryData, intl) {
    const themes = {};

    Object.entries(categoryData).forEach(([code, data]) => {
        const theme = data.theme || '99';
        if (!themes[theme]) {
            themes[theme] = {
                name: intl.formatMessage({ id: 'theme.' + theme, defaultMessage: theme }),
                taxonomy: [],
                custom: []
            };
        }

        const displayName = getTopicDisplayName(code, data, intl);
        const item = { code, data, displayName };

        if (data.taxonomy) {
            themes[theme].taxonomy.push(item);
        } else {
            themes[theme].custom.push(item);
        }
    });

    return themes;
}

export function filterTopicsBySearch(themes, searchText, intl) {
    if (!searchText) return themes;
    const lower = searchText.toLowerCase();

    const filtered = {};
    Object.entries(themes).forEach(([theme, group]) => {
        const themeNameMatch = group.name.toLowerCase().includes(lower);

        const matchedTaxonomy = themeNameMatch
            ? group.taxonomy
            : group.taxonomy.filter(item => item.displayName.toLowerCase().includes(lower));

        const matchedCustom = themeNameMatch
            ? group.custom
            : group.custom.filter(item => item.displayName.toLowerCase().includes(lower));

        if (matchedTaxonomy.length > 0 || matchedCustom.length > 0) {
            filtered[theme] = { ...group, taxonomy: matchedTaxonomy, custom: matchedCustom };
        }
    });

    return filtered;
}
